import { styled } from "@linaria/react";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  &[data-justify="between"] {
    justify-content: space-between;
  }

  &[data-justify="center"] {
    justify-content: center;
  }

  &[data-justify="end"] {
    justify-content: flex-end;
  }

  &[data-align="start"] {
    align-items: flex-start;
  }

  &[data-align="center"] {
    align-items: center;
  }

  &[data-align="end"] {
    align-items: flex-end;
  }

  &[data-width="full"] {
    width: 100%;
  }

  &[data-width="min"] {
    width: min-content;
  }

  &[data-height="full"] {
    height: 100%;
  }

  &[data-gap="none"] {
    gap: 0;
  }
`;

export const RowLabel = styled.label`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
